import i18n from '@/i18n';

/** Minimal fields for delivery / address popover copy (shared: collaborations row + Profiles card). */
export type DeliveryAddressInput = {
  address: string;
  product_delivery?: string | null;
  address_available?: boolean;
};

export type DeliveryAddressPopoverConfig = {
  title: string;
  body: string;
  triggerLabel: string;
  /** When false, show trigger text only (no popover / not clickable). */
  interactive: boolean;
};

/** Popover copy for delivery / address; null = show static "No address yet" (when no delivery type). */
export function getDeliveryAddressPopover(c: DeliveryAddressInput): DeliveryAddressPopoverConfig | null {
  const pd = (c.product_delivery ?? '').toString().toUpperCase();
  const hasAddr = Boolean(c.address_available && c.address !== '–');
  const t = (key: string) => i18n.t(`contentReview.delivery.${key}`);

  if (pd === 'DIGITAL') {
    return {
      title: t('digitalTitle'),
      triggerLabel: t('digitalTrigger'),
      body: hasAddr ? c.address : t('digitalBodyGeneric'),
      interactive: true,
    };
  }
  if (pd === 'SHIPPING') {
    return {
      title: t('shippingTitle'),
      triggerLabel: hasAddr ? t('shippingViewAddress') : t('shippingNoAddress'),
      body: hasAddr ? c.address : t('shippingNoAddressBody'),
      interactive: hasAddr,
    };
  }
  if (pd === 'NONE' || pd === '') {
    return null;
  }
  if (hasAddr) {
    return { title: t('otherTitle'), triggerLabel: t('otherViewDelivery'), body: c.address, interactive: true };
  }
  return null;
}
